import styled from 'react-emotion';
import { theme, Avatar as UnstyledAvatar } from '@ublend-npm/aulaui-next';

export const Container = styled('div')`
  display: flex;
  align-items: ${({ row }) => (row ? 'center' : 'initial')};
`;

export const Description = styled('div')`
  display: flex;
  align-items: ${({ row }) => (row ? 'center' : 'flex-start')};
  height: ${({ row }) => (row ? `${theme.spacing.xLarge}` : 'initial')};
  font-family: 'Work Sans', sans-serif;
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.size.copy};
  flex-direction: ${({ row }) => (row ? 'row' : 'column')};
  justify-content: ${({ row }) => (row ? 'flex-start' : 'space-between')};
`;

export const Avatar = styled(UnstyledAvatar)`
  margin-right: 12px;
  flex-shrink: 0;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
`;

export const Title = styled('span')`
  font-weight: 600;
  font-size: 14px;
  color: #1a1a1a;
`;

export const Subtitle = styled('span')`
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  margin-left: ${({ row }) => (row ? '8px' : 0)};
`;
